import { render, staticRenderFns } from "./DishTotalSettings.vue?vue&type=template&id=27eff32f&"
import script from "./DishTotalSettings.vue?vue&type=script&lang=js&"
export * from "./DishTotalSettings.vue?vue&type=script&lang=js&"
import style0 from "./DishTotalSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports